module.exports = __webpack_public_path__ + "static/media/TOELF.7678e279.png";